import { useAuthContext } from './useAuthContext';
import { usePaymentsContext } from './usePaymentsContext';

export const useLogout = () => {
	const { dispatch } = useAuthContext();
	const { dispatch: paymentsDispatch } = usePaymentsContext();

	const logout = () => {
		localStorage.removeItem('user');

		dispatch({ type: 'LOGOUT' });
		paymentsDispatch({ type: 'SET_PAYMENTS', payload: null });
	};

	return { logout };
};
